const PLATFORM_LABELS: Record<string, string> = {
  instagram: 'Instagram',
  tiktok: 'TikTok',
};

// Deliberately NOT caseUtils.capitalizeFirstLetter: that helper preserves the
// tail ("TIKTOK" → "TIKTOK"), while platform labels need a normalized tail.
const capitalize = (s: string) =>
  s.length ? s[0].toUpperCase() + s.slice(1).toLowerCase() : s;

/** "tiktok" → "TikTok"; ["tiktok","instagram"] → "TikTok & Instagram". */
export const formatPlatforms = (platforms: string[]): string =>
  platforms.length
    ? platforms
        .map((p) => PLATFORM_LABELS[p.toLowerCase()] ?? capitalize(p))
        .join(' & ')
    : '-';
